import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import ResizableUISortTH from '../../resizing/components/ResizableSortTH';

const Header = ({
  column,
  columnIndex,
  isLastColumn,
  sortDirection,
  onColumnWidthChange,
  onColumnOrderChange,
  onSortChange,
  numberOfFrozenColumns
}) => /*#__PURE__*/_jsx(ResizableUISortTH, {
  column: column,
  columnIndex: columnIndex,
  isLastColumn: isLastColumn,
  numberOfFrozenColumns: numberOfFrozenColumns,
  sortDirection: sortDirection,
  onColumnWidthChange: onColumnWidthChange,
  onColumnOrderChange: onColumnOrderChange,
  onSortChange: onSortChange,
  children: /*#__PURE__*/_jsx(column.HeaderContentComponent, {
    columnNamespace: column.columnNamespace,
    columnName: column.columnName
  })
});

export default /*#__PURE__*/memo(Header);